import React from "react";
import {Button, Paper, ClickAwayListener, TextField} from "@material-ui/core";
import "./Transactions.css"
import Autocomplete from "@material-ui/lab/Autocomplete";
import PropTypes from "prop-types";
import withShipment from "../../../withShipment";

class ImportTransactionsPopper extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedBankAccount: null,
        }
    }

    handleClose = () => {
        this.props.handleClosePopper()
    }

    handleSave = () => {
        this.props.callback(this.state.selectedBankAccount)
        this.props.handleClosePopper()
    }

    render() {
        return (
            <>
                <ClickAwayListener onClickAway={this.handleClose}>
                    <Paper className="import-popper-container">
                        <div className="import-popper-item">
                            <Autocomplete
                                options={this.props.bankAccounts}
                                getOptionLabel={(option) => `${option.name} (${option.accountNumber})`}
                                value={this.state.selectedBankAccount}
                                onChange={(e, value) => this.setState({selectedBankAccount: value})}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        name="bankAccount"
                                        label="Select a Bank Account"
                                        variant="outlined"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                }
                                style={{width: "250px"}}
                            />
                        </div>
                        <div className="supplier-payment-popper-buttons">
                            <Button variant='contained' onClick={this.handleClose} style={{width: '100px'}}>Close</Button>
                            <Button variant='contained' onClick={this.handleSave} color="primary" style={{width: '100px'}}>Next</Button>
                        </div>
                    </Paper>
                </ClickAwayListener>
            </>
        )
    }
}

ImportTransactionsPopper.propTypes = {
    bankAccounts: PropTypes.array
}

ImportTransactionsPopper.defaultProps = {
    bankAccounts: [],
}

export default withShipment({
}, ImportTransactionsPopper);